// extracted by mini-css-extract-plugin
module.exports =  {"contact-seller-button":"KWxTIXC","contactSellerButton":"KWxTIXC","avatar":"RAIQcv7"};